import moment from 'moment'

export default class DataUtils {
	static getTextoVencimento(data) {
		return moment(data).local().fromNow()
	}

	static isVencido(data) {
		return moment(data).local().isBefore(moment().local(), 'day')
	}

	static isProximoAVencer(data, diasLimite) {
		const hoje = moment().local().startOf('day')
		const dataLimite = moment().local().add(diasLimite, 'days').endOf('day')
		const dataComparada = moment(data).local().startOf('day')

		return dataComparada.isBetween(hoje, dataLimite, 'day', '[]')
	}

	static isDiferencaEntreDatasMenorIgualA(dataDe, dataAte, amount, unit) {
		return this.setUltimaHoraDoDia(dataAte).isSameOrBefore(
			this.setUltimaHoraDoDia(moment(dataDe).local().add(amount, unit)),
		)
	}

	static isDiferencaEntreDatasMenorQueQtdAnos(dataDe, dataAte, anos) {
		return this.setUltimaHoraDoDia(dataAte).isSameOrBefore(
			this.setUltimaHoraDoDia(moment(dataDe).local().add(anos, 'year').subtract(1, 'day')),
		)
	}

	static getLocalDateValue(data) {
		return moment(data).local().toISOString(true)
	}

	static setUltimaHoraDoDia(data) {
		return moment(data).local().hour(23).minute(59).second(59).millisecond(0)
	}

	static setAdicionarMaisUmAno(data) {
		return moment(data).add(365, 'days').local().hour(0).minute(0).second(0).millisecond(0).toISOString(true)
	}

	static setAdicionarMaisDias(data, amount) {
		return moment(data).add(amount, 'days').toISOString(true)
	}

	static setDateTimeOffSetFromDate(data) {
		const dataJaFormatada = data.length !== 10
		if (dataJaFormatada) return data

		const dataISO = `${data}T12:00:00`
		return new Date(dataISO).toISOString()
	}

	static setDateTimeOffSetFromLocaleDate(data) {
		const [dia, mes, ano] = data.split('/')
		const dataISO = `${ano}-${mes}-${dia}T12:00:00`
		return new Date(dataISO).toISOString()
	}
}
